export default function AmparoBio() {
  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center gap-12">
          {/* Photo */}
          <div className="flex-shrink-0 w-48 h-48 md:w-64 md:h-64 rounded-full overflow-hidden">
            <img
              src="https://static.readdy.ai/image/592edeeb72878c36421bcef1375eb795/01ab1dbddc88ed5da8ca907842d906d0.jpeg"
              alt="Amparo Jarquin - Florida Real Estate Agent"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* Text */}
          <div>
            <p className="text-amber-600 text-xs font-semibold tracking-widest uppercase mb-2">Your Listing Agent</p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-1">
              Amparo <span className="text-amber-500">Jarquin</span>
            </h2>
            <p className="text-gray-400 text-sm font-medium mb-5 tracking-wide">Licensed Florida REALTOR® · 24+ Years Experience</p>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              Amparo Jarquin is a dedicated Florida real estate professional with over 24 years of experience helping families sell their homes for maximum value. Her deep knowledge of Florida neighborhoods, market trends, and buyer psychology means your property gets the right exposure to the right people — fast.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed">
              Warm, strategic, and relentlessly thorough, Amparo manages every detail from listing to closing so you can focus on what comes next.
            </p>
            <div className="flex flex-wrap gap-6 mt-6">
              {[
                { value: '130+', label: 'Homes Sold' },
                { value: '$20M+', label: 'Sales Volume' },
                { value: '98%', label: 'Client Satisfaction' },
              ].map((s) => (
                <div key={s.label} className="text-center">
                  <p className="text-2xl font-bold text-amber-500">{s.value}</p>
                  <p className="text-xs text-gray-500 font-medium mt-0.5">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
